import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["skeleton", "preview"]

  connect() {
    this.form = document.getElementById("user_form") // This should be set as target
  }

  show(event) {
    event.preventDefault()
    this.renderPreview()
  }

  hide(event) {
    event.preventDefault()
    this.toggleVisibility(false)
  }

  async renderPreview() {
    const data = {
      name: this.value("user[name]"),
      gender: this.value("user[gender]") || "Not provided",
      location: this.value("user[location]") || "Not provided",
      date_of_birth: this.form.querySelector("input[type='date']")?.value || "Not provided",
      email: this.value("user[email]") || "Not provided",
    }

    const isVip = this.form.querySelector("input[name='user[is_vip]'][type='checkbox']")?.checked
    const isBlacklisted = this.form.querySelector("input[name='user[is_blacklisted]'][type='checkbox']")?.checked

    if (isBlacklisted) {
      data.tag = "Blacklist"
    } else if (isVip) {
      data.tag = "VIP"
    } else {
      data.tag = "User"
    }

    const imageInputs = Array.from(this.form.querySelectorAll("input[type='file'][name^='user[image']"))
    const imageDataUrls = await Promise.all(imageInputs.map(this.readImage))

    const profileImage = imageDataUrls[0] ||  "/assets/default-profile-pic-icon.png"
    const otherImages = imageDataUrls.slice(1).filter(Boolean)

    this.previewTarget.innerHTML = this.previewHTML(data, profileImage, otherImages)
    this.toggleVisibility(true)
  }

  value(name) {
    const input = this.form.querySelector(`[name='${name}']`)
    return input?.value || ""
  }

  readImage(input) {
    return new Promise(resolve => {
      if (input?.files?.[0]) {
        const reader = new FileReader()
        reader.onload = e => resolve(e.target.result)
        reader.readAsDataURL(input.files[0])
      } else {
        resolve(null)
      }
    })
  }

  toggleVisibility(showPreview) {
    this.previewTarget.classList.toggle("hidden", !showPreview)
    this.skeletonTarget.classList.toggle("hidden", showPreview)
  }

  previewHTML(data, profileImage, otherImages) {
    const imagesHTML = otherImages.length
      ? otherImages.map(url => `<img src="${url}" class=" bg-gray-100 border border-gray-200 w-24 h-24 rounded-lg object-cover" />`).join("")
      : `<p class="text-gray-400 italic">No additional images.</p>`

    return `
      <div class="border-b-8 border-s border-t border-e border-gray-200 rounded-xl p-[18px] bg-white w-full">
        <h1 class="text-[#131313] text-xl font-extrabold mb-3">Profile Summary</h1>
        <div class="flex items-center gap-4 mb-6">
            <div class="w-12 h-12 rounded-lg bg-gray-100 border border-gray-200">
                <img src="${profileImage}" class="w-full h-full object-cover" />
            </div>
            <div class="flex-1">
                <h4 class="text-base font-semibold text-gray-900 leading-tight">${data.name}</h4>
                <p class="text-sm text-gray-500 font-medium">IT Department</p>
            </div>
        </div>

        <div class="space-y-2 mb-4">
          <p class="text-sm text-gray-500">Uploaded Images:</p>
          <div class="flex gap-2 flex-wrap">${imagesHTML}</div>
        </div>

        <div class="space-y-2">
          <div class="flex"><p class="w-40 text-sm text-gray-500">Gender:</p><p class="text-base font-medium text-gray-800">${data.gender}</p></div>
          <div class="flex"><p class="w-40 text-sm text-gray-500">Email:</p><p class="text-base font-medium text-gray-800">${data.email}</p></div>
          <div class="flex"><p class="w-40 text-sm text-gray-500">Location:</p><p class="text-base font-medium text-gray-800">${data.location}</p></div>
          <div class="flex"><p class="w-40 text-sm text-gray-500">Date of Birth:</p><p class="text-base font-medium text-gray-800">${data.date_of_birth}</p></div>
        </div>

        <div class="my-4 border-t border-gray-300"></div>

       <div class="flex justify-between items-center">
          <span>${data.tag}</span>
          <a href="#" class="text-white rounded-full md:px-8 px-4 md:py-4 py-2 bg-[#0445D8] font-bold text-sm border border-[#0445D8]" data-action="click->profile-preview#hide">Hide Preview</a>
        </div>
      </div>
    `
  }
}
